<script setup lang="ts">
interface Props {
  redirect?: boolean | string;
}

const props = withDefaults(defineProps<Props>(), {
  redirect: true,
});

const config = useRuntimeConfig();
const authStore = useAuthStore();
const buttonRef = ref<HTMLElement | null>(null);

function initGoogleButton() {
  if (!window.google?.accounts?.id || !buttonRef.value) return;

  window.google.accounts.id.initialize({
    client_id: config.public.googleClientId as string,
    callback: handleCredentialResponse,
    context: "signin",
  });

  window.google.accounts.id.renderButton(buttonRef.value, {
    size: "large",
    text: "signin_with",
    shape: "pill",
    type: "standard",
    theme: "outline",
    logo_alignment: "center",
  });

  window.google.accounts.id.prompt();
}

onMounted(() => {
  if (!import.meta.client) return;

  // If GSI script is already loaded (e.g. from nuxt head config), init immediately
  if (window.google?.accounts?.id) {
    initGoogleButton();
    return;
  }

  // Otherwise dynamically load the script
  const script = document.createElement("script");
  script.src = "https://accounts.google.com/gsi/client";
  script.async = true;
  script.defer = true;
  script.onload = () => initGoogleButton();
  document.head.appendChild(script);
});

async function handleCredentialResponse(response: { credential: string }) {
  await authStore.googleAuth({
    token: { idToken: response.credential },
    redirect:
      typeof props.redirect === "string" ? props.redirect : props.redirect ? "/orders" : undefined,
  });
}
</script>

<template>
  <div
    ref="buttonRef"
    class="google-button"
  />
</template>

<style lang="scss">
.google-button {
  margin: 0 auto;
  width: 100%;
  iframe {
    width: 100%;
  }
}
</style>
